import React from 'react';
import { Plug, ShieldAlert, FileWarning } from 'lucide-react';
import { motion } from 'framer-motion';

const FeaturesSection = () => {
  const features = [
    {
      icon: Plug,
      title: 'Seamless Integration',
      description: 'Connect your existing workflows and apps without disruption. Guardifix drops into Slack, Google Workspace, and Microsoft 365 so your team never skips a beat.',
      accent: 'blue',
    },
    {
      icon: ShieldAlert,
      title: 'Advanced Threat Protection',
      description: 'AI-driven filters analyze every inbound message in real time, blocking phishing attempts, malware payloads, and zero-day attacks before they reach your inbox.',
      accent: 'emerald',
    },
    {
      icon: FileWarning,
      title: 'Data Loss Prevention',
      description: 'Intelligent, dynamic policies detect sensitive content and prevent accidental data leaks. Set rules by department, classification level, or custom triggers.',
      accent: 'blue',
    },
  ];

  return (
    <section data-testid="features-section" className="py-24 sm:py-32 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              data-testid={`feature-card-${index}`}
              className="bg-white border border-slate-200 rounded-2xl p-8 hover:-translate-y-1 hover:shadow-xl hover:border-slate-300 transition-all duration-300 group"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 ${
                feature.accent === 'blue' ? 'bg-blue-100' : 'bg-emerald-100'
              }`}>
                <feature.icon className={`h-6 w-6 ${
                  feature.accent === 'blue' ? 'text-blue-700' : 'text-emerald-600'
                }`} strokeWidth={2} />
              </div>

              <h3 className="text-xl font-bold text-slate-900 mb-3 tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
                {feature.title}
              </h3>

              <p className="text-slate-500 leading-relaxed text-sm">
                {feature.description}
              </p>

              <div className="mt-6">
                <div className={`h-0.5 w-0 group-hover:w-full transition-all duration-500 ${
                  feature.accent === 'blue' ? 'bg-blue-700' : 'bg-emerald-500'
                }`} />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
